import Dialog from '#lib/components/dialog.jsx';
import { DiffReport } from './diff/diff-report.jsx';

export default function PendingUpdatesModal(props) {
    const { isOpen, onClose, diffModel, itineraryOptions, totalDocs } = props;
    return (
        <Dialog isOpen={isOpen} onClose={onClose}>
            <Dialog.Panel className="flex flex-col gap-4 min-w-[350px] w-full max-w-[800px] max-h-[80vh] overflow-auto">
                <div className="w-full pr-4">
                    <Dialog.CloseButton />
                    <p className="text-2xl">{_t.edit.showPendingUpdates()}</p>
                </div>
                <DiffReport
                    diff={diffModel}
                    options={{
                        itineraryOptions,
                        totalDocs
                    }}
                />
            </Dialog.Panel>
        </Dialog>
    );
}
